import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=d87b521e&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=d87b521e&scoped=true&lang=scss"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=d87b521e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87b521e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d87b521e')) {
      api.createRecord('d87b521e', component.options)
    } else {
      api.reload('d87b521e', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=d87b521e&scoped=true", function () {
      api.rerender('d87b521e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderInfo.vue"
export default component.exports